var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDesignIcon = function SvgDesignIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38.13 33.49",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a, .c, .d, .e, .f {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .a {\n        fill: url(#a);\n      }\n\n      .b {\n        fill: #fff;\n      }\n\n      .c {\n        fill: url(#b);\n      }\n\n      .d, .e {\n        stroke-width: 0.5px;\n      }\n\n      .d {\n        fill: url(#c);\n      }\n\n      .e {\n        fill: url(#d);\n      }\n\n      .f {\n        fill: url(#e);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    "data-name": "Gradient bez nazwy 20",
    x1: 0.5,
    y1: 6.78,
    x2: 13.06,
    y2: 6.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6523b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#8629cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a72fe0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 23.8,
    y1: 26.07,
    x2: 37.63,
    y2: 26.07,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 24.99,
    y1: 5.38,
    x2: 34.39,
    y2: 5.38,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 2.08,
    y1: 28.29,
    x2: 11.48,
    y2: 28.29,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 8.87,
    y1: 17.19,
    x2: 29.69,
    y2: 17.19,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.5,
    y: 0.5,
    width: 12.56,
    height: 12.56
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.49,7.85l-.6,1.81H3.12l2-5.75H6l2,5.75H7.15L6.53,7.85Zm1.89-.58L5.82,5.61a10,10,0,0,1-.3-1.05h0c-.09.34-.18.7-.29,1.05L4.65,7.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.57,4.37a.44.44,0,0,1-.47.46.45.45,0,0,1-.46-.46.46.46,0,0,1,.47-.47A.44.44,0,0,1,9.57,4.37ZM8.74,9.66V5.53h.75V9.66Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 23.8,
    y: 19.15,
    width: 13.84,
    height: 13.84
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27.49,23a8.86,8.86,0,0,1,1.57-.13,2.61,2.61,0,0,1,1.78.53,1.69,1.69,0,0,1,.55,1.33,1.86,1.86,0,0,1-.49,1.35,3.14,3.14,0,0,1-2.59.64v2.55h-.82ZM28.31,26a3.07,3.07,0,0,0,.67.06c1,0,1.59-.48,1.59-1.35S30,23.5,29.08,23.5a3.2,3.2,0,0,0-.77.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32.31,26.11c0-.54,0-1,0-1.42H33l0,.89h0a1.35,1.35,0,0,1,1.26-1l.23,0v.79a1.14,1.14,0,0,0-.28,0,1.16,1.16,0,0,0-1.11,1.06,2.23,2.23,0,0,0,0,.39v2.43h-.82Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 24.99,
    y: 0.68,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27.15,6.19l-.44,1.35h-.58l1.46-4.31h.68l1.47,4.31h-.6l-.46-1.35Zm1.42-.44-.43-1.24c-.09-.28-.16-.54-.22-.78h0c-.07.25-.14.51-.22.78l-.42,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.59,6.1a1,1,0,0,0,1.06,1.07A2,2,0,0,0,32.5,7l.1.4a2.49,2.49,0,0,1-1,.2,1.44,1.44,0,0,1-1.52-1.56A1.5,1.5,0,0,1,31.5,4.38a1.31,1.31,0,0,1,1.28,1.46,1.61,1.61,0,0,1,0,.26Zm1.65-.41a.81.81,0,0,0-.78-.91.94.94,0,0,0-.87.91Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 2.08,
    y: 23.59,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.14,30.46l-.55-.95c-.22-.36-.36-.6-.5-.85h0c-.12.25-.24.48-.46.86l-.52.94H3.46l1.32-2.18L3.51,26.15h.65l.56,1c.16.28.29.49.4.72h0c.12-.25.23-.45.39-.72l.59-1h.64l-1.31,2.1,1.34,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10,25.92v3.75c0,.27,0,.58,0,.79h-.5l0-.53h0a1.14,1.14,0,0,1-1.05.6A1.41,1.41,0,0,1,7.12,29,1.49,1.49,0,0,1,8.51,27.3a1,1,0,0,1,.93.47h0V25.92Zm-.56,2.71a1,1,0,0,0,0-.24.82.82,0,0,0-.81-.65c-.58,0-.93.51-.93,1.2s.31,1.14.92,1.14a.85.85,0,0,0,.82-.67.93.93,0,0,0,0-.24Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 8.87,
    y: 6.78,
    width: 20.82,
    height: 20.82
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.94,12.55a14.22,14.22,0,0,1,2.37-.19,4,4,0,0,1,2.67.79,2.59,2.59,0,0,1,.83,2,2.83,2.83,0,0,1-.73,2,4,4,0,0,1-2.91,1,4.41,4.41,0,0,1-1-.08V22H13.94Zm1.23,4.59a4.18,4.18,0,0,0,1,.1c1.49,0,2.39-.72,2.39-2s-.89-1.87-2.25-1.87a5,5,0,0,0-1.16.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21,20.69a3.28,3.28,0,0,0,1.64.5c.91,0,1.33-.45,1.33-1s-.35-.92-1.27-1.26c-1.23-.44-1.81-1.12-1.81-1.94a2.11,2.11,0,0,1,2.36-2,3.37,3.37,0,0,1,1.68.43l-.31.91a2.65,2.65,0,0,0-1.4-.4c-.73,0-1.14.42-1.14.93s.41.82,1.3,1.16c1.18.45,1.79,1.05,1.79,2.07,0,1.2-.93,2.05-2.56,2.05a3.92,3.92,0,0,1-1.92-.47Z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDesignIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DesignIcon.4db97b36.svg";
export { ForwardRef as ReactComponent };